import React from "react";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft, FaVideo } from "react-icons/fa";

// Live sessions are parked. The route stays mounted so existing links and
// bookmarks don't 404, but the page shows a "coming soon" placeholder and makes
// NO API calls — nothing from /api/live-sessions is surfaced to students yet.
//
// The previous implementation (session list + register/unregister) is in git
// history; restore it here when the feature is ready to ship.
const LiveSessions = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-gray-50 font-montserrat">
            <nav className="bg-[#2148C0] shadow-md px-4 sm:px-6 py-4 flex items-center gap-4">
                <button onClick={() => navigate(-1)} className="text-white shrink-0" aria-label="Go back">
                    <FaArrowLeft size={18} />
                </button>
                <h1 className="text-lg sm:text-xl font-bold text-white">Live Sessions</h1>
            </nav>

            <ComingSoon
                message="Live classes with your teachers are on the way. You'll be able to see what's scheduled and join right here."
                onBack={() => navigate(-1)}
            />
        </div>
    );
};

// Shared placeholder body — kept here (rather than in components/) because it
// exists only for this parked feature and goes away with it.
export const ComingSoon = ({ message, onBack }) => (
    <div className="max-w-xl mx-auto px-4 sm:px-6 py-20 text-center">
        <span className="w-16 h-16 rounded-2xl bg-blue-50 text-blue-600 flex items-center justify-center mx-auto">
            <FaVideo size={24} />
        </span>
        <h2 className="mt-5 text-2xl font-bold text-gray-900">Coming soon</h2>
        <p className="mt-2 text-gray-500 leading-relaxed">{message}</p>
        {onBack && (
            <button
                onClick={onBack}
                className="mt-6 bg-blue-600 hover:bg-blue-700 text-white px-5 py-2.5 rounded-xl font-semibold"
            >
                Go back
            </button>
        )}
    </div>
);

export default LiveSessions;
